// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Link: 'link',
	AddTitleButton: 'add-title-button',
	Container: 'container',
	Container1: 'container-1',
	PropertyDetailsContainer: 'property-details-container',
	AdditionalDetailsContainer: 'additional-details-container',
	Container2: 'container-2',
	Container3: 'container-3',
	NextInstallmentDueDatePicker: 'next-installment-due-date-picker',
	SurveyDateDatePicker: 'survey-date-date-picker',
	RollNumber: 'roll-number',
	BuilderNumber: 'builder-number',
	SurveyorName: 'surveyor-name',
	ParcelOfTiedLandOverview: 'parcel-of-tied-land-overview',
	SelectedRegistrationMethodRadioGroup:
		'selected-registration-method-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
